module.exports = __webpack_public_path__ + "static/img/bangding_01.1bb76be4.jpg";